const EmailParticipantTypes = Object.freeze({
  CONSTITUENT: 'constituent',
  EMPLOYEE: 'employee',
  UNKNOWN: 'unknown',
});

export default EmailParticipantTypes;
